import { RolePermissions } from "enums";
import AddUserButton from "features/People/Users/UsersOverview/AddUserButton";
import { noop } from "lodash";

type Props = {
  shouldRender?: boolean;
  onImportUsers: (onConfirm: () => void) => void;
  onCreateUser: (onConfirm: () => void) => void;
  tooltipPosition?: string;
};

export const AddTemplateUserButton = (props: Props) => {
  const { shouldRender = true, onImportUsers, onCreateUser, tooltipPosition } = props;
  return (
    <AddUserButton
      shouldRender={shouldRender}
      createPermissions={[RolePermissions.UsersManage, RolePermissions.TemplatesManage]}
      permissionPredicate={(userPermissions) => {
        const requiredPermissions = [RolePermissions.UsersManage, RolePermissions.TemplatesManage];
        return requiredPermissions.every((permission) => userPermissions.includes(permission));
      }}
      onImportUsers={() => onImportUsers(noop)}
      onCreateUser={() => onCreateUser(noop)}
      tooltipPosition={tooltipPosition}
    />
  );
};
